<script >

import {setState, getState} from "../../../../../stores.js";

var productsHeader = [
		{
			title: "Products"
		}
];

export let companyProducts = null;
export let openProduct = false;
export let editProduct = false;
export let selectedProduct = null;

const openProductHandler = (productName) =>{
	openProduct = true;
	setState('openProduct',true);
	selectedProduct = productName;
	setState('selectedProduct',productName );
}

const editProductHandler = (productName) =>{
	editProduct = true;
	setState('editProduct',true);
	selectedProduct = productName;
	setState('selectedProduct',productName );
}

</script>


<div class="meanTableContainer">
						
		<div class="meanTableRow">
			{#each productsHeader as header,index}
				<div class="meanTableRowItem header">
					{header.title}
				</div>
			{/each}

		</div>

		{#if companyProducts != null}
			{#if companyProducts.length > 0}
				{#each companyProducts as product}
					<div class="meanTableRow">
						<div class="meanTableRowItem">{product.name}</div>
						<div class="meanTableRowItem actionBtnContainer" >
							<div class="actionBtn"on:click={() => openProductHandler(product.name)}>Open</div>
							<div class="actionBtn" on:click={() =>editProductHandler(product.name)}>Edit</div>	
						</div>
						
					</div>
					
				{/each}
			{:else}
				<div class="meanTableRow">
					<div class="infoText">No products available.</div>
				</div>
			{/if}
		{:else}
			<div class="meanTableRow">
				<div class="infoText">Add or Join a company to add or manage products.</div>
			</div>
		{/if}

</div>



<style >


	.meanTableContainer{
		width: 90%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-items: flex-start;
		gap: 5%;
		overflow-y: scroll;
		scrollbar-width: none;
	}

	::-webkit-scrollbar {
		    width: 0em;
	}



	.meanTableRow{
		width: 50%;
		height: 10%;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		background-color: transparent;
		/*border-bottom-color: black;
		border-bottom-width:  0.06510416666666667vw;
		border-bottom-style: solid;*/
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-5px);
		border-radius: 3px;
		flex-grow: 0;
		flex-shrink: 0;
		margin-left: 1%;

	}

	.meanTableRow:nth-child(1){
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0); 
		transform: translateY(0px);
		position: sticky !important;
	}

	.header{
		font-size: 1.0416666666666667vw !important;
	}

	.meanTableRowItem{
		width: 25%;
		height: 100%;
		color: black;
		display: flex;
		align-items: center;
		font-size: 0.8463541666666666vw;
		font-weight: 700;
		/*opacity: 0.8;*/
	}

	.meanTableRow > .meanTableRowItem:nth-child(1){
		margin-left: 1%;
	}

	.infoText{
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.8463541666666666vw;
		font-weight: 700;
		color: black;
	}

	.textOrange{
		width: 25% !important;
		color: #FFAE6A !important;
	}

	.actionBtnContainer{
		width: 75%;
		height: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
	}

	.actionBtn{
		width: 20%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		
	}

	.actionBtn:hover{
		color:  var(--brand-accent);
	}

</style>